var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.703171 1.08326V3.25005C0.700708 3.51717 0.79732 3.77553 0.974122 3.97587L9.36979 13.4118V24.9169C9.36834 25.1188 9.42337 25.3171 9.52865 25.4894C9.63393 25.6617 9.78527 25.8012 9.9656 25.892C10.1174 25.9656 10.2843 26.0027 10.453 26.0004C10.6876 26.0004 10.9156 25.9243 11.1031 25.7836L15.4366 22.5336C15.5712 22.4327 15.6804 22.3018 15.7556 22.1513C15.8308 22.0009 15.8699 21.835 15.8699 21.6668V13.4118L24.2658 3.97587C24.4425 3.7756 24.539 3.51712 24.5368 3.25005V1.08326C24.5368 0.940957 24.5087 0.80005 24.4543 0.668587C24.3998 0.537124 24.3199 0.417683 24.2193 0.317086C24.1187 0.216489 23.9992 0.136708 23.8677 0.0823011C23.7362 0.0278945 23.5953 -7.17675e-05 23.453 1.38309e-07H1.78643C1.49913 1.38309e-07 1.2236 0.114129 1.02045 0.317279C0.8173 0.52043 0.703171 0.795961 0.703171 1.08326Z",
    fill: "#FEFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.47ba2e2f2f13d6f556ea5ecd7d8aa8dd.svg";
export { ForwardRef as ReactComponent };